<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: JoinUs
 * @Description: 人才招聘
 * @FilePath: /app-tikfriend_web/src/pages/content/JoinUs.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-12 00:48:00
 * @LastEditors: hselenat
 * @LastEditTime: 2021-08-13 17:48:38
 * @example: 调用示例
-->
<template>
    <div class="joinus-x">
        <div class="asid-x">
            <div class="aside-items" v-for="(item, index) in jobData" :key="index">
                <div class="aside-item" :class="selectId == item.id ? 'active' : ''" @click="gotoJob(item)"><pre>{{ item.jobName }}</pre></div>
            </div>
        </div>
        <div class="job-x">
            <component :is="'JobItem'" :jobItemData="jobItemData"></component>
        </div>
    </div>
</template>

<script>
  import JobItem from '@/components/JobItem.vue'
  export default {
      name: 'JoinUs',
      components: {
        JobItem
      },
      data() {
        return {
          selectId: 0,
          jobData: this.$joinapi.jobData,
          jobItemData: []
        }
      },
      created() {
        this.init()
      },
      methods: {
        init() {
          this.jobData = this.$joinapi.jobData
          this.jobItemData = this.$joinapi.jobData[0].allJobs
        },
        gotoJob(item) {
          let that = this
          that.selectId = item.id
          that.jobItemData = item.allJobs
        }
      }
  }
</script>
